import { ButcherHeader } from '@components/ButcherHeader';
import { SideNav } from '@components/OrderCreation/OrderSideNav';
import { OrderListBreadcrumbs } from '@components/OrderProcessing/OrderListBreadcrumbs';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  AppSettingsSteps,
  OrderProcessingMasterData,
} from '@helpers/Constants';
import { FrontendRoutes } from '@helpers/Constants/Navigation';
import { useNavigate } from 'react-router-dom';

export const AppSettings: React.FC = () => {
  const navigate = useNavigate();

  const BreadCrumbsProps = {
    steps: AppSettingsSteps,
    activeItem: 'All Orders',
    type: OrderProcessingMasterData.APP_SETTINGS,
  };

  return (
    <div className="flex h-screen w-screen">
      <SideNav active={10} />
      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        {/* Header */}
        <ButcherHeader />
        <OrderListBreadcrumbs orderInfo={BreadCrumbsProps} />
        <div className="flex-1 flex flex-col overflow-auto p-1">
          <div className="flex justify-between items-center">
            <h1 className="font-semibold text-xl px-2 mt-1">App Settings</h1>
          </div>
          {/* Main Card */}
          <div className="mt-5 rounded-md border border-[#0000001F] p-3">
            {/* Profile Details */}
            <button
              type="button"
              onClick={() => navigate(FrontendRoutes.PROFILE_DETAILS)}
              className="w-full text-left"
            >
              <div className="flex items-center justify-between p-3">
                <div className="flex items-center gap-2">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM0 16V13.2C0 12.6333 0.145833 12.1125 0.4375 11.6375C0.729167 11.1625 1.11667 10.8 1.6 10.55C2.63333 10.0333 3.68333 9.64583 4.75 9.3875C5.81667 9.12917 6.9 9 8 9C9.1 9 10.1833 9.12917 11.25 9.3875C12.3167 9.64583 13.3667 10.0333 14.4 10.55C14.8833 10.8 15.2708 11.1625 15.5625 11.6375C15.8542 12.1125 16 12.6333 16 13.2V16H0ZM2 14H14V13.2C14 13.0167 13.9542 12.85 13.8625 12.7C13.7708 12.55 13.65 12.4333 13.5 12.35C12.6 11.9 11.6917 11.5625 10.775 11.3375C9.85833 11.1125 8.93333 11 8 11C7.06667 11 6.14167 11.1125 5.225 11.3375C4.30833 11.5625 3.4 11.9 2.5 12.35C2.35 12.4333 2.22917 12.55 2.1375 12.7C2.04583 12.85 2 13.0167 2 13.2V14ZM8 6C8.55 6 9.02083 5.80417 9.4125 5.4125C9.80417 5.02083 10 4.55 10 4C10 3.45 9.80417 2.97917 9.4125 2.5875C9.02083 2.19583 8.55 2 8 2C7.45 2 6.97917 2.19583 6.5875 2.5875C6.19583 2.97917 6 3.45 6 4C6 4.55 6.19583 5.02083 6.5875 5.4125C6.97917 5.80417 7.45 6 8 6Z"
                      fill="black"
                    />
                  </svg>
                  <span className="text-[#555F71] font-medium">
                    Profile Details
                  </span>
                </div>
                <FontAwesomeIcon icon={faAngleRight} />
              </div>
            </button>

            <div className="border-b border-[#0000001F]"></div>

            {/* About Application */}
            <button
              type="button"
              onClick={() => navigate('/about-application')}
              className="w-full text-left"
            >
              <div className="flex items-center justify-between p-3">
                <div className="flex items-center gap-2">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 15H11V9H9V15ZM10 7C10.2833 7 10.5208 6.90417 10.7125 6.7125C10.9042 6.52083 11 6.28333 11 6C11 5.71667 10.9042 5.47917 10.7125 5.2875C10.5208 5.09583 10.2833 5 10 5C9.71667 5 9.47917 5.09583 9.2875 5.2875C9.09583 5.47917 9 5.71667 9 6C9 6.28333 9.09583 6.52083 9.2875 6.7125C9.47917 6.90417 9.71667 7 10 7ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                      fill="black"
                    />
                  </svg>
                  <span className="text-[#555F71] font-medium">
                    About Application
                  </span>
                </div>
                <FontAwesomeIcon icon={faAngleRight} />
              </div>
            </button>

            <div className="border-b border-[#0000001F]"></div>
            {/* Help/FAQ */}
            <button
              type="button"
              onClick={() => navigate('/help-faq')}
              className="w-full text-left"
            >
              <div className="flex items-center justify-between p-3">
                <div className="flex items-center gap-2">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 15C9.35 15 9.64583 14.8792 9.8875 14.6375C10.1292 14.3958 10.25 14.1 10.25 13.75C10.25 13.4 10.1292 13.1042 9.8875 12.8625C9.64583 12.6208 9.35 12.5 9 12.5C8.65 12.5 8.35417 12.6208 8.1125 12.8625C7.87083 13.1042 7.75 13.4 7.75 13.75C7.75 14.1 7.87083 14.3958 8.1125 14.6375C8.35417 14.8792 8.65 15 9 15ZM8.1 11.15H9.95C9.95 10.55 10.0167 10.1083 10.15 9.825C10.2833 9.54167 10.5667 9.18333 11 8.75C11.5833 8.16667 11.9958 7.67917 12.2375 7.2875C12.4792 6.89583 12.6 6.45 12.6 5.95C12.6 5.06667 12.3 4.35417 11.7 3.8125C11.1 3.27083 10.2917 3 9.275 3C8.35833 3 7.57917 3.225 6.9375 3.675C6.29583 4.125 5.85 4.75 5.6 5.55L7.25 6.2C7.36667 5.75 7.6 5.3875 7.95 5.1125C8.3 4.8375 8.70833 4.7 9.175 4.7C9.625 4.7 10 4.82083 10.3 5.0625C10.6 5.30417 10.75 5.625 10.75 6.025C10.75 6.30833 10.6583 6.60833 10.475 6.925C10.2917 7.24167 9.98333 7.59167 9.55 7.975C9 8.45833 8.62083 8.92083 8.4125 9.3625C8.20417 9.80417 8.1 10.4 8.1 11.15ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V2H2V16Z"
                      fill="black"
                    />
                  </svg>
                  <span className="text-[#555F71] font-medium">Help/FAQ</span>
                </div>
                <FontAwesomeIcon icon={faAngleRight} />
              </div>
            </button>
            <div className="border-b border-[#0000001F]"></div>
            {/* Subscription */}
            <button
              type="button"
              onClick={() => navigate('/subscription/details')}
              className="w-full text-left"
            >
              <div className="flex items-center justify-between p-3">
                <div className="flex items-center gap-2">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V8C0 7.45 0.195833 6.97917 0.5875 6.5875C0.979167 6.19583 1.45 6 2 6H18C18.55 6 19.0208 6.19583 19.4125 6.5875C19.8042 6.97917 20 7.45 20 8V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H2ZM2 18H18V8H2V18ZM8 17L14 13L8 9V17ZM2 5V3H18V5H2ZM5 2V0H15V2H5Z"
                      fill="black"
                    />
                  </svg>
                  <span className="text-[#555F71] font-medium">
                    Subscription
                  </span>
                </div>
                <FontAwesomeIcon icon={faAngleRight} />
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
